import { Button } from '@/components/ui/button';
import { Modal } from '@/components/ui/modal';
import { Typography } from '@/components/ui/typography';

interface Props {
  open: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

/** Shown when a user turns Auto-Sync Assets back on for AppFolio (single-family-only delivery). */
const AppfolioAutoSyncConfirmModal = ({ open, onConfirm, onCancel }: Props) => (
  <Modal
    open={open}
    onOpenChange={(next) => !next && onCancel()}
    title="Auto-Sync Assets"
    size="md"
    footer={
      <>
        <Button type="button" variant="outline" onClick={onCancel} className="w-full sm:w-auto">
          Cancel
        </Button>
        <Button type="button" onClick={onConfirm} className="w-full sm:w-auto">
          I, Understand
        </Button>
      </>
    }
  >
    <div className="flex flex-col gap-3">
      <Typography as="p" variant="body-semibold">
        This integration will deliver completed PlanOmatic photos only to the Single Family
        properties in your AppFolio account.
      </Typography>
      <Typography as="p" variant="body" className="text-muted-foreground">
        We are currently unable to deliver photos of Multi-Family Units through the integration.
        Those photos will be available for download from PlanOmatic and will require a manual
        upload into your AppFolio account.
      </Typography>
    </div>
  </Modal>
);

export default AppfolioAutoSyncConfirmModal;
